import { _, mui, Navigate, React, Route, Routes, ts, ui, useLocation } from '_core';

import { loadPublicFeatures } from './authentication/authentication-utils/api-procedures';

const RegisterLazy = React.lazy(() => import('./authentication/register'));
const LoginLazy = React.lazy(() => import('./authentication/login'));
const SignUpLazy = React.lazy(() => import('./authentication/sign-up'));
const ForgotPasswordLazy = React.lazy(() => import('./authentication/forgot-password'));
const PasswordResetLazy = React.lazy(() => import('./authentication/password-reset'));
const TermsLazy = React.lazy(() => import('./authentication/terms'));

const RegisterDeferred = ({ features }: { features: ts.types.organization.OrganizationFeaturesDraft }) => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <RegisterLazy features={features} />
    </React.Suspense>
  );
};

const LoginDeferred = ({ features }: { features: ts.types.organization.OrganizationFeaturesDraft }) => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <LoginLazy features={features} />
    </React.Suspense>
  );
};

const SignUpDeferred = ({ features }: { features: ts.types.organization.OrganizationFeaturesDraft }) => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <SignUpLazy features={features} />
    </React.Suspense>
  );
};

const ForgotPasswordDeferred = ({ features }: { features: ts.types.organization.OrganizationFeaturesDraft }) => (
  <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
    <ForgotPasswordLazy features={features} />
  </React.Suspense>
);

const PasswordResetDeferred = ({ features }: { features: ts.types.organization.OrganizationFeaturesDraft }) => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <PasswordResetLazy features={features} />
    </React.Suspense>
  );
};

const TermsDeferred = () => {
  return (
    <React.Suspense fallback={<ui.CenteredLoader top="-100px" />}>
      <TermsLazy />
    </React.Suspense>
  );
};

const LoggedOutRouter = () => {
  const [loading, setLoading] = React.useState(true);
  const [publicFeatures, setPublicFeatures] = React.useState<ts.types.organization.OrganizationFeatures>({} as any);

  const initialLoad = () =>
    loadPublicFeatures(
      (resp: ts.types.organization.OrganizationFeatures) => {
        setLoading(true);
        setPublicFeatures(resp);
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );

  React.useEffect(() => {
    initialLoad();
  }, []);

  const loc = useLocation();

  if (loading) return <ui.CenteredLoader />;

  return (
    <>
      {_.isEmpty(publicFeatures) && !loc.pathname.includes('/register') && (
        <mui.core.Alert severity="warning" sx={{ position: 'fixed', width: '100%', zIndex: 1000 }}>
          Unable to load public features for the organization. Please review the subdomain.
        </mui.core.Alert>
      )}
      <ui.NonAuthLayout>
        <Routes>
          <Route path="/register" element={<RegisterDeferred features={publicFeatures} />} />
          <Route path="/password-reset" element={<PasswordResetDeferred features={publicFeatures} />} />
          <Route path="/forgot-password" element={<ForgotPasswordDeferred features={publicFeatures} />} />
          <Route path="/terms" element={<TermsDeferred />} />
          {publicFeatures.free_sign_up && (
            <Route path="/sign-up" element={<SignUpDeferred features={publicFeatures} />} />
          )}
          <Route path="/" element={<LoginDeferred features={publicFeatures} />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </ui.NonAuthLayout>
    </>
  );
};

export default LoggedOutRouter;
